"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _jsxRuntime = require("react/jsx-runtime");

var _templateObject, _templateObject2;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledButtonWrapper = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  width: 50px;\n  min-width: 50px;\n  max-width: 50px;\n"])));

var StyledButton = _styledComponents.default.button(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  width: 100%;\n  height: 24px;\n  border-radius: 12px;\n\n  font-size: 0.7rem;\n  background: ", ";\n  color: ", ";\n\n  ", ";\n"])), function (p) {
  return p.disabled ? p.theme.colorDisabledBackground : p.isSuccess ? p.theme.colorSuccess : p.theme.colorPrimary;
}, function (p) {
  return p.disabled ? p.theme.colorDisabledText : p.isSuccess ? p.theme.colorSuccessText : p.theme.colorPrimaryText;
}, function (p) {
  return p.disabled && "cursor: not-allowed";
});

var Wrapper = function Wrapper(_ref) {
  var children = _ref.children,
      disabled = _ref.disabled,
      onClick = _ref.onClick,
      index = _ref.index,
      isSuccess = _ref.isSuccess;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledButtonWrapper, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledButton, {
      disabled: disabled,
      onClick: onClick,
      isSuccess: isSuccess,
      children: children
    })
  });
};

var _default = Wrapper;
exports.default = _default;